export default __webpack_public_path__ + "static/media/Sansita-ExtraBold.20c2e826.ttf";